import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'partner_login',
      component: () => import('./views/page/partner/Login.vue'),
      meta: {
        title: 'ログインページ',
      },
    },
    {
      path: '/partner_top',
      name: 'partner_top',
      component: () => import('./views/template/Partner.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/partner/List.vue'),
          meta: {
            title: '船積一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner_tanto',
      name: 'partner_tanto',
      component: () => import('./views/template/Partner.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/partner/Tanto.vue'),
          meta: {
            title: '担当者一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner_edit',
      name: 'partner_edit',
      component: () => import('./views/template/Partner.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/partner/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
        {
          path: 'detail/:id',
          component: () => import('./views/page/partner/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner_logout',
      name: 'partner_logout',
      component: () => import('./views/page/partner/Logout.vue'),
      meta: {
        title: 'ログアウトページ',
      },
    },
    {
      path: '/shiptask',
      name: 'login',
      component: () => import('./views/page/Login.vue'),
      meta: {
        title: 'ログインページ',
      },
    },
    {
      path: '/top',
      name: 'top',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/Fc.vue'),
          meta: {
            title: '船積一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/tanto',
      name: 'tanto',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/Tanto.vue'),
          meta: {
            title: '担当者一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/tanto_edit',
      name: 'tanto_edit',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
        {
          path: 'detail/:id',
          component: () => import('./views/page/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/customer',
      name: 'customer',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/Customer.vue'),
          meta: {
            title: 'お客様一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/customer_edit',
      name: 'customer_edit',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/CustomerEdit.vue'),
          meta: {
            title: 'お客様管理',
            pankuzu: [],
          },
        },
        {
          path: 'detail/:id',
          component: () => import('./views/page/CustomerEdit.vue'),
          meta: {
            title: 'お客様管理',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/customs_broker',
      name: 'customs_broker',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/CustomsBroker.vue'),
          meta: {
            title: '通関業者一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/customs_broker_edit',
      name: 'customs_broker_edit',
      component: () => import('./views/template/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/CustomsBrokerEdit.vue'),
          meta: {
            title: '通関業者管理',
            pankuzu: [],
          },
        },
        {
          path: 'detail/:id',
          component: () => import('./views/page/CustomsBrokerEdit.vue'),
          meta: {
            title: '通関業者管理',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/page/Logout.vue'),
      meta: {
        title: 'ログアウトページ',
      },
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('./views/page/customs_broker/Login.vue'),
      meta: {
        title: 'ログインページ',
      },
    },
    {
      path: '/partner/top',
      name: 'partnerTop',
      component: () => import('./views/template/CustomsBrokerMain.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/customs_broker/Fc.vue'),
          meta: {
            title: '船積一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner/tanto',
      name: 'partnerTanto',
      component: () => import('./views/template/CustomsBrokerMain.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/customs_broker/Tanto.vue'),
          meta: {
            title: '担当者一覧',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner/tanto_edit',
      name: 'partnerTantoEdit',
      component: () => import('./views/template/CustomsBrokerMain.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/customs_broker/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
        {
          path: 'detail/:id',
          component: () => import('./views/page/customs_broker/TantoEdit.vue'),
          meta: {
            title: '担当者管理',
            pankuzu: [],
          },
        },
      ],
    },
    {
      path: '/partner/logout',
      name: 'partnerLogout',
      component: () => import('./views/page/customs_broker/Logout.vue'),
      meta: {
        title: 'ログアウトページ',
      },
    },
    //404のルートなので1番最後に記述する
    {
      path: '*',
      name: '404',
      component: () => import('./views/template/404.vue'),
      meta: {
        title: '404',
      },
    },
  ]
});